export const generateQueryParams = ({
  orderBy,
  sortDirection,
  equalsTo,
  search,
  chipStatus,
  status,
}: {
  orderBy?: string;
  sortDirection?: string;
  equalsTo?: string;
  search?: string;
  chipStatus?: string;
  status?: string;
}) => {
  const params: { [key: string]: string } = {};

  if (orderBy && sortDirection) {
    params[`OrderBy[${orderBy}]`] = sortDirection;
  }

  if (equalsTo && search) {
    params[`EqualsTo[${equalsTo}]`] = search;
  }

  if (chipStatus && status) {
    params[`EqualsTo[${chipStatus}]`] = status;
  }

  return params;
};
